module.exports = __webpack_public_path__ + "static/media/weight-up.7305ca2d.png";